import Image from '@components/Image'
import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import { ElementHTML } from '@helpers/helper.rendering'
const AboutUs16 = (props: RealEstateDataPageComponentData) => {
  const {
    image_gatsby,
    title,
    paragraphElement,
    titleElement,
    opacityValue,
    paragraphs,
    button,
    opacityGradient,
    alignCenter,
  } = props

  const normalizedOpacity = Number(opacityValue) / 100

  return (
    <section className={`about-us-16 a`}>
      <div
        className="opacity"
        style={{
          opacity: opacityGradient
            ? 1
            : opacityValue && opacityValue !== '0'
            ? Number(opacityValue) !== 100
              ? normalizedOpacity
              : 1
            : 0.6,
          background: opacityGradient
            ? `linear-gradient(to right,rgba(0, 0, 0, ${normalizedOpacity}), rgba(0, 0, 0, 0))`
            : '',
        }}
      ></div>
      <Image
        className="w-90 h-100 background-image-absolute no-border"
        objectFit="cover"
        alt="about-us-img"
        image={image_gatsby!!}
      />
      <Container
        fluid
        className={`d-flex py-lg-5 h-100 align-items-${alignCenter ? 'center' : 'end'}`}
      >
        <Row className="d-flex justify-content-between align-items-end">
          <Col
            lg={5}
            xs={12}
            className="my-5 my-lg-0"
          >
            {title && (
              <ElementHTML
                children={title!}
                elementType={titleElement || 'p'}
                className="section-name mb-5"
              />
            )}
            {paragraphs?.map((paragraph, index) => (
              <ElementHTML
                key={index}
                children={paragraph}
                elementType={paragraphElement || 'h5'}
                className="sub-section mb-lg-4 mb-3"
              />
            ))}
          </Col>
          {button?.value && (
            <Col
              xs={12}
              lg={2}
              className="mt-lg-5 d-flex justify-content-start justify-content-lg-end mb-lg-4 mb-3"
            >
              <Link
                to={button?.link!}
                className={'btn  btn-white' + (button?.border ? ' border' : '')}
              >
                {button!.value}
              </Link>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs16
